import 'reflect-metadata';
import { Service } from 'typedi';
import { StrategyBuilder } from '../../StrategyBuilder';
import type { SearchersData } from '../../types/searchers-data.type';
import { ISearchersStrategyService } from '../../SearcherNamesStrategyService';
import { makeLogger } from '../../../../logger/logger';

const { warn } = makeLogger({
  pathToCurrentFile: 'components/strategies/services/searcher-names-service/searcher-names.service.ts',
  loggersList: ['warn'],
});

@Service({ id: 'searcherNamesStrategyService' })
export class SearcherNameBuilder extends StrategyBuilder<ISearchersStrategyService> {
  build(details: SearchersData): ISearchersStrategyService {
      return new SearcherNamesStrategyService(details);
  }
}

export class SearcherNamesStrategyService extends ISearchersStrategyService {
  details;
  constructor(details: SearchersData) {
      super();
      this.details = details;
  }

  dashboardSearchers = [
    'all',
    'default',
    'products',
    'documents',
    'software',
    'faq',
    'company',
    'solutions',
    'services',
    'support',
    'marketo',
    'orders',
    'quotes',
    'trainings',
    'topics',
    'support/products',
    'support/video',
    'support/community',
  ];

  dashboardSearchersApc = [
    'all',
    'products',
    'documents',
    'software',
    'faq',
    'blog'
  ];

  mapSearchersToDashboard() {
      const newObject = {};
      const params = this.details?.params;
      const predefinedSearchers = params?.predefinedSearchers;
      const brand = params?.brand;
      const brandSearchers = (brand === 'se' || brand === 'myschneider') ? this.dashboardSearchers : this.dashboardSearchersApc;

      if (predefinedSearchers && brand) {
        for (let i = 0; i < this.dashboardSearchers.length; i++) {
          const detailsKey = Object.keys(predefinedSearchers)[i];

          if (brandSearchers.includes(detailsKey)) {
            newObject[detailsKey] = predefinedSearchers[detailsKey];
          } else {
            warn(
              `The ${detailsKey} key is not valid according to the strategy used`
            );
          }
        }

        const boundledData = { predefinedSearchers: newObject, brand };

        return boundledData;
      }

      warn(
        'The strategy does not have the correct searchers or application name'
      );

      return {};
  }
}
